import { render, staticRenderFns } from "./MeasureConfigOptions.vue?vue&type=template&id=5681dddd&scoped=true"
import script from "./MeasureConfigOptions.vue?vue&type=script&lang=js"
export * from "./MeasureConfigOptions.vue?vue&type=script&lang=js"
import style0 from "./MeasureConfigOptions.vue?vue&type=style&index=0&id=5681dddd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5681dddd",
  null
  
)

export default component.exports